export const operationAbbreviation = {
  CAPITAL_DECREASE: 'Abbreviation_CapitalDecrease',
  CAPITAL_INCREASE: 'Abbreviation_CapitalIncrease',
  CONSTITUTION: 'Abbreviation_Constitution',
  CONTRIBUTION: 'Abbreviation_Contribution',
  DIVIDENDS_DISTRIBUTION: 'Abbreviation_DividendsDistribution',
  DONATION: 'Abbreviation_Donation',
  ENDORSEMENT: 'Abbreviation_Endorsement',
  HERITAGE: 'Abbreviation_Heritage',
  RECLASSIFICATION: 'Abbreviation_Reclassification',
  RENUMERATION: 'Abbreviation_Renumeration',
  SELL_PARTICIPATION: 'Abbreviation_SellParticipation',
  SPLIT: 'Abbreviation_Split',
  TRANSMISSION: 'Abbreviation_Transmission',
  // Aliases
  OP_ALIAS_AMORTIZATION: 'Abbreviation_OP_ALIAS_AMORTIZATION',
  OP_ALIAS_INITIAL_LOAD: 'Abbreviation_OP_ALIAS_INITIAL_LOAD',
  OP_ALIAS_MERGER_BY_ABSORPTION: 'Abbreviation_OP_ALIAS_MERGER_BY_ABSORPTION',
  OP_ALIAS_SHARETITLES_CANCELLATION:
    'Abbreviation_OP_ALIAS_SHARETITLES_CANCELLATION',
};
